import { render } from "./ReflectionForm.vue?vue&type=template&id=900a7fe6"
import script from "./ReflectionForm.vue?vue&type=script&lang=ts"
export * from "./ReflectionForm.vue?vue&type=script&lang=ts"
script.render = render

export default script